import { Component, Vue, Inject } from "vue-property-decorator";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { User } from "../models/User";
import { Http } from "@status/codes";
import {
  LOGIN_CONSTANTS,
  REGISTER_CONSTANS
} from "../constants/LoginConstants";
import { AuthService } from "../services/AuthService";
import VueRecaptcha from "vue-recaptcha";
import Snackbar from "@/shared/components/Snackbar/Snackbar";

@Component({
  name: "Register",
  components: {
    VueRecaptcha
  }
})
export default class Register extends Vue {
  @Inject() authService!: AuthService;

  cardClass = STYLE_CLASSES.CARD;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  priBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;

  PAGE_TITLE = REGISTER_CONSTANS.PAGE_TITLE;
  NAME = REGISTER_CONSTANS.LABEL.NAME;
  EMAIL = REGISTER_CONSTANS.LABEL.EMAIL;
  ID_DOC = REGISTER_CONSTANS.LABEL.USER;
  PASSWORD = REGISTER_CONSTANS.LABEL.PASSWORD;
  CONFIRM_PASS = REGISTER_CONSTANS.LABEL.CONFIRM_PASS;
  REGISTER_BTN = REGISTER_CONSTANS.BUTTON.REGISTER;
  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  SITE_KEY = process.env.VUE_APP_SITE_KEY;

  alphanumericPatter = [FORM_VALIDATORS.ALPHANUMERIC_PATTERN];
  emailField = [FORM_VALIDATORS.EMAIL_FIELD];
  requiredField = [FORM_VALIDATORS.REQUIRED_FIELD];

  passwordRules = [
    (v: string) => v.length >= 8 || REGISTER_CONSTANS.MESSAGE.MIN_LENGTH
  ];

  idDoc = "";
  userDB = "";
  user = "";
  password = "";
  repeatPass = "";
  registerForm = false;
  isAppointment = false;
  disabled = false;
  captchaValue = "";
  loadingServices = false;

  async mounted() {
    if (this.$route.params.info) {
      try {
        const resp = await this.authService.decodeToken(
          this.$route.params.info,
          this.$route.params.userId
        );

        if (resp.code === Http.Ok) {
          this.PAGE_TITLE = REGISTER_CONSTANS.CREATE_PASSWORD_TITLE;
          this.disabled = true;
          this.idDoc = resp.data.id;
          this.userDB = resp.data.docDB;
        } else {
          Snackbar.popError(REGISTER_CONSTANS.MESSAGE.LINK_NOT_VALID);
          this.$router.replace(LOGIN_CONSTANTS.URL_LOGIN);
        }
      } catch (error) {
        return Snackbar.popError(REGISTER_CONSTANS.MESSAGE.LINK_NOT_VALID);
      }
    }
  }

  async register() {
    if (this.registerForm) {
      this.loadingServices = true;
      if (!this.disabled) {
        await this.sendWhatsapp();
      } else {
        try {
          const userToSave: User = {
            password: this.password,
            basicInfo: {
              idNumber: this.idDoc
            },
            docId: this.userDB
          };

          const resp = await this.authService.registerUser(userToSave);

          if (resp.code === Http.Ok) {
            this.loadingServices = false;
            Snackbar.popSuccess(REGISTER_CONSTANS.MESSAGE.SAVED_USER);
            this.$router.replace(LOGIN_CONSTANTS.URL_LOGIN);
          }
        } catch (error) {
          this.loadingServices = false;
          Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
        }
      }
    } else {
      this.loadingServices = false;
      Snackbar.popWarning(FORM_MESSAGES.FORM_ERRORS);
    }
  }

  async sendWhatsapp() {
    if (this.idDoc && this.captchaValue) {
      try {
        const resp = await this.authService.sendWhatsapp(this.idDoc);

        if (resp.code === Http.Found && resp.data) {
          const user = await this.authService.loginByToken(resp.data.userToken);
          const token = await user.user?.getIdToken();

          this.authService.updateToken(token as string);

          this.loadingServices = false;

          Snackbar.popSuccess(REGISTER_CONSTANS.MESSAGE.CONFIRM_MESSAGE);
          this.$router.replace(LOGIN_CONSTANTS.URL_LOGIN);
        } else if (resp.code === Http.Ok) {
          this.loadingServices = false;
          return Snackbar.popSuccess(resp.message);
        } else {
          this.loadingServices = false;
          return Snackbar.popError(resp.message);
        }
      } catch (error) {
        this.loadingServices = false;
        return Snackbar.popError(REGISTER_CONSTANS.MESSAGE.ERROR_RETRY);
      }
    } else {
      this.loadingServices = false;
      Snackbar.popWarning(FORM_MESSAGES.FORM_ERRORS);
    }
  }

  matchPassword() {
    return (
      this.repeatPass === this.password || REGISTER_CONSTANS.MESSAGE.MATCH_PASS
    );
  }

  onVerify(response: string) {
    this.captchaValue = response;
  }
}
